var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#F3F0FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.66602H9.33333H20",
    stroke: "#FF6464",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3359 9.66667V8.33333C11.3359 7.97971 11.4764 7.64057 11.7265 7.39052C11.9765 7.14048 12.3156 7 12.6693 7H15.3359C15.6896 7 16.0287 7.14048 16.2787 7.39052C16.5288 7.64057 16.6693 7.97971 16.6693 8.33333V9.66667M18.6693 9.66667V19C18.6693 19.3536 18.5288 19.6928 18.2787 19.9428C18.0287 20.1929 17.6896 20.3333 17.3359 20.3333H10.6693C10.3156 20.3333 9.97651 20.1929 9.72646 19.9428C9.47641 19.6928 9.33594 19.3536 9.33594 19V9.66667H18.6693Z",
    stroke: "#FF6464",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6641 13V17",
    stroke: "#FF6464",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3359 13V17",
    stroke: "#FF6464",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.b7e948dbf47706a281d9ca9561b66909.svg";
export { ForwardRef as ReactComponent };